module.exports = __webpack_public_path__ + "static/img/footcode.ac4b1ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footcode.jpg
// module id = 3CUG
// module chunks = 5